export async function showGateUseCase(showGateData, gateRepostitory) {
    const result = await gateRepostitory.show(showGateData);

    const entity = new gateRepostitory.model(result)
    
    if (!entity.isValid()) {
      throw new Error("Portal inválido");
    }

    return entity;
}